import axiosInstance from "./axiosInstance";


const AuthService = {
    login: async (credentials) => {
        const response = await axiosInstance.post(`/authenticate`, credentials);
        return response.data; // Assume the API returns a token or user data
    },

    refresh: async (jwtToken) => {
        console.log("refreshing token: " + jwtToken)
        const response = await axiosInstance.post(`/check`, jwtToken);
        return response.data; // Assume the API returns a token or user data
    },

    status: async () => {
        const response = await axiosInstance.post(`/status`);
        return response.data;
    },

    register: async (data) => {
        const response = await axiosInstance.post(`/api/auth/register`, data);
        return response.data;
    },

    account: async () => {
        const response = await axiosInstance.get(`/api/auth/account`);
        return response.data;
    },
};

export default AuthService;
